module.exports = __webpack_public_path__ + "static/img/planRight1.e43bbb50.png";